export default __webpack_public_path__ + "static/media/JB.4723f6c9.png";